var map = {
	"./_constmap1.png": "e8f3",
	"./_constmap2.png": "ae27",
	"./_constmap3.png": "942c",
	"./_posmap1.png": "729d",
	"./_posmap2.png": "14ec",
	"./_posmap3.png": "d2ec",
	"./_starmap1.png": "12b3",
	"./_starmap2.png": "17bd",
	"./_starmap3.png": "8417",
	"./aquila.png": "b283",
	"./bootes.png": "3bd9",
	"./cancer.png": "47f9",
	"./cepheus.png": "6fd5",
	"./cetus.png": "ecce",
	"./crater.png": "92f3",
	"./draco.png": "c0f9",
	"./gemini.png": "1104",
	"./lacerta.png": "7260",
	"./leo.png": "7c61",
	"./lepus.png": "4d72",
	"./lyra.png": "2b25",
	"./pegasus.png": "d435",
	"./phoenix.png": "dfee",
	"./pisces.png": "896d",
	"./puppis.png": "6721",
	"./scorpius.png": "0687",
	"./ursa_major.png": "f832",
	"./ursa_minor.png": "2dad",
	"./virgo.png": "cf82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa3";